import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <Link to="/" className="brand">
              <span className="mark">
                <LogoMark />
              </span>
              Ghi Âm Pro
            </Link>
            <p>
              Giải pháp ghi âm cuộc họp, chuyển giọng nói thành văn bản và tự động hoá biên bản,
              kết luận, nhiệm vụ sau họp bằng trí tuệ nhân tạo.
            </p>
          </div>

          <div>
            <h4>Sản phẩm</h4>
            <ul>
              <li>
                <Link to="/tinh-nang">Tính năng</Link>
              </li>
              <li>
                <Link to="/giai-phap">Giải pháp theo ngành</Link>
              </li>
              <li>
                <Link to="/bang-gia">Bảng giá</Link>
              </li>
              <li>
                <Link to="/bao-mat">Bảo mật & hạ tầng</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Công ty</h4>
            <ul>
              <li>
                <Link to="/gioi-thieu">Giới thiệu</Link>
              </li>
              <li>
                <Link to="/lien-he">Liên hệ</Link>
              </li>
              <li>
                <Link to="/gioi-thieu">Quy trình triển khai</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Hỗ trợ</h4>
            <ul>
              <li>
                <Link to="/lien-he">Yêu cầu demo</Link>
              </li>
              <li>
                <Link to="/lien-he">Tư vấn triển khai</Link>
              </li>
              <li>
                <Link to="/bao-mat">Chính sách dữ liệu</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Ghi Âm Pro. Mọi quyền được bảo lưu.</span>
          <span>Ghi âm cuộc họp · Phiên âm tiếng Việt · Biên bản & nhiệm vụ tự động</span>
        </div>
      </div>
    </footer>
  );
}
